
const state = {
  content: {
    firstname: null,
    lastname: null,
    amount: null,
    certificatename: null,
    showCertificate: false,
    showWildcard: false,
    wildcardurl: null,
    certificateurl: null,
    isMonthly: false,
    isOpen: false,
    title: '',
    message: '',
    shareButton: false,
    recommendedReading: false,
    component: '',
    componentparams: '',
  },
  openDonationPopup: false,
  openPetitionPopup: false,
  openPetitionMessagePopup: false,
  openEarthHourPopup: false,
};

const getters = {
  content: state => state.content,
  openDonationPopup: state => state.openDonationPopup,
  openPetitionPopup: state => state.openPetitionPopup,
  openPetitionMessagePopup: state => state.openPetitionMessagePopup,
  openEarthHourPopup: state => state.openEarthHourPopup,
};

const mutations = {
  setPopupContent: function (state, data) {
    state.content = { ...state.content, ...data };
  },
  openDonationPopup(state, openPopup) {
    state.openDonationPopup = openPopup;
  },
  openPetitionPopup(state, openPopup) {
    state.openPetitionPopup = openPopup;
  },
  openPetitionMessagePopup(state, openPopup) {
    state.openPetitionMessagePopup = openPopup;
  },
  openEarthHourPopup(state, openPopup) {
    state.openEarthHourPopup = openPopup;
  }
};

const actions = {};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/popup.js